<template>
    <router-view />
    <v-layout class="rounded rounded-md">
      <TopBar/>
  
      <!-- メニュー -->
      <TopMenu/>

      <!-- メイン -->
      <v-main class="align-center justify-center" style="min-height: 300px;">
        <LoginParts/>
      </v-main>
  
      <!-- フッター -->
      <v-footer app color="primary">
      </v-footer>
    </v-layout>
  </template>
  
  <script>
  import TopBar from '@/components/TopBar.vue'
  import TopMenu from '@/components/TopMenu.vue'
  import LoginParts from '@/components/LoginParts.vue'
  
  export default {
    name: 'App',
    components: {
        TopBar,
        TopMenu,
        LoginParts,
    },
  }
  </script>
  